// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accueil-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.accueil-modal {
  background: #ffffff;
  border-radius: 8px;
  width: min(1300px, calc(100vw - 2rem));
  max-width: 100%;
  height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

@media screen and (max-width: 640px) {
  .accueil-modal-overlay {
    padding: 1rem;
    align-items: center;
  }

  .accueil-modal {
    width: 100%;
    max-width: 100%;
    height: 88dvh;
    border-radius: 12px;
  }

  .accueil-modal-header {
    padding: 1rem 1.25rem;
  }
}

.accueil-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.accueil-modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #595959;
  margin: 0;
}

.accueil-modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  color: #6b7280;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition:
    color 0.15s,
    background-color 0.15s;
}

.accueil-modal-close:hover {
  color: #374151;
  background-color: #f3f4f6;
}

.accueil-modal-body {
  padding: 0;
  overflow-y: auto;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.accueil-modal-body:has(.accueil-video-wrapper) {
  overflow: hidden;
  flex: none;
}

.accueil-modal--video {
  height: auto;
  width: min(900px, calc(100vw - 2rem));
}

.accueil-modal--video .accueil-modal-body {
  overflow: hidden;
  flex: none;
}

.accueil-modal-body .annuaire-cards-grid {
  grid-template-columns: repeat(4, 1fr);
}

@media screen and (max-width: 960px) {
  .accueil-modal-body .annuaire-cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 480px) {
  .accueil-modal-body .annuaire-cards-grid {
    grid-template-columns: 1fr;
  }
}


.accueil-modal-body {
  padding: 1.5rem 3rem;
}

.accueil-modal-body .accueil-video-wrapper {
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/composants/AccueilModal/AccueilModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB;;0BAEwB;AAC1B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".accueil-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.accueil-modal {\n  background: #ffffff;\n  border-radius: 8px;\n  width: min(1300px, calc(100vw - 2rem));\n  max-width: 100%;\n  height: 85vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n@media screen and (max-width: 640px) {\n  .accueil-modal-overlay {\n    padding: 1rem;\n    align-items: center;\n  }\n\n  .accueil-modal {\n    width: 100%;\n    max-width: 100%;\n    height: 88dvh;\n    border-radius: 12px;\n  }\n\n  .accueil-modal-header {\n    padding: 1rem 1.25rem;\n  }\n}\n\n.accueil-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.accueil-modal-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #595959;\n  margin: 0;\n}\n\n.accueil-modal-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  line-height: 1;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  transition:\n    color 0.15s,\n    background-color 0.15s;\n}\n\n.accueil-modal-close:hover {\n  color: #374151;\n  background-color: #f3f4f6;\n}\n\n.accueil-modal-body {\n  padding: 0;\n  overflow-y: auto;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.accueil-modal-body:has(.accueil-video-wrapper) {\n  overflow: hidden;\n  flex: none;\n}\n\n.accueil-modal--video {\n  height: auto;\n  width: min(900px, calc(100vw - 2rem));\n}\n\n.accueil-modal--video .accueil-modal-body {\n  overflow: hidden;\n  flex: none;\n}\n\n.accueil-modal-body .annuaire-cards-grid {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n@media screen and (max-width: 960px) {\n  .accueil-modal-body .annuaire-cards-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .accueil-modal-body .annuaire-cards-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n.accueil-modal-body {\n  padding: 1.5rem 3rem;\n}\n\n.accueil-modal-body .accueil-video-wrapper {\n  border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
